// react
import { useEffect, useRef, useState } from 'react';

// styles
import css from './HorizontalSection.module.scss';

// framer motion
import { motion } from 'framer-motion';

// components
import DescriptionPage from '../description/DescriptionPage';
import Priorities from '../Priorities/Priorities';

// Гистерезис: назад в позицию 0 возвращаемся, только когда верх секции ушёл
// ниже верха экрана больше чем на этот запас. Раньше порог назад был 0px против
// 2px вперёд, и инерционный скролл Safari дёргал позицию туда-сюда, каждый раз
// монтируя/демонтируя половину страницы (мерцание, зависание скролла).
const BACK_THRESHOLD = 40;

const HorizontalSection = ({ width, setRightScrolled, rightScrolled }) => {
    const containerRef = useRef(null);
    const [currentPosition, setCurrentPosition] = useState(0);
    const [scrollLocked, setScrollLocked] = useState(false);
    const positions = width < 1024 ? ['0%', '0%'] : ['0', 'calc(-100% - 4px)'];

    useEffect(() => {
        if (scrollLocked) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [scrollLocked]);

    useEffect(() => {
        if (width < 1024) return;
        if (scrollLocked)
            setTimeout(() => {
                setScrollLocked(false);
            }, 1000);
    }, [scrollLocked, width]);

    useEffect(() => {
        if (currentPosition === 1) setRightScrolled(true);
        else setRightScrolled(false);
    }, [currentPosition]);

    // Одна проверка на кадр в обе стороны. Раньше возврат в 0 шёл через
    // scrollYProgress (при пустом Priorities секция ровно 100vh, диапазон useScroll
    // вырожденный — прогресс прыгал 0/1) плюс preventDefault на 'scroll',
    // который ничего не делает: это событие не отменяемое.
    useEffect(() => {
        const block = containerRef.current;
        if (!block || width < 1024) return;

        let rafId = null;
        const checkPosition = () => {
            rafId = null;
            const pos = block.getBoundingClientRect();
            if (currentPosition === 0 && pos.bottom - 2 <= window.innerHeight) {
                setCurrentPosition(1);
            } else if (currentPosition === 1 && pos.top > BACK_THRESHOLD) {
                setCurrentPosition(0);
            }
        };
        const listener = () => {
            if (rafId === null) {
                rafId = requestAnimationFrame(checkPosition);
            }
        };
        window.addEventListener('scroll', listener, { passive: true });
        // window.addEventListener('touchmove', listener);
        return () => {
            window.removeEventListener('scroll', listener);
            // window.removeEventListener('touchmove', listener);
            if (rafId !== null) {
                cancelAnimationFrame(rafId);
            }
        };
    }, [containerRef.current, width, currentPosition]);

    useEffect(() => {
        if (width < 1024) {
            setScrollLocked(false);
        }
    }, [width]);

    return (
        <div style={{ position: 'relative', overflow: 'hidden' }}>
            <motion.div
                ref={containerRef}
                style={{
                    x: positions[currentPosition],
                    transition: 'transform 1s ease'
                }}
            >
                <div className={css.horizontalWrapper}>
                    <DescriptionPage />
                    <Priorities rightScrolled={rightScrolled} />
                </div>
            </motion.div>
        </div>
    );
};

export default HorizontalSection;
